<div class="d-flex flex-column align-items-center">
    <div class="dialog-header">
        <div class="icon-wrapper">
            <span
                hamIconShapes
                class="shield-check-icon"
                icon="assets/hamIcons/shield-check.svg"
                [variant]="'yellow'"
                [size]="'lg'"
                class="no-hover"
            ></span>
        </div>
        <span class="dialog-header__title">{{ 'aumico_annual_report_confirmation_seal_dialog_title' | i18next }}</span>
    </div>
    <div class="dialog-body">
        <span class="dialog-body__text">
            {{ 'aumico_annual_report_confirmation_seal_dialog_description' | i18next }}
        </span>
    </div>
</div>
